@import (reference) '../../../../../constants/spacing.module.less';

.feature-line-item {
  padding-bottom: @space-4;
}

.feature-expander-button {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: @space-4;
  padding-bottom: @space-4;
}

.feature-expander-icon {
  height: 16px;
}
